<div class="vehicle-type-global-selection-wrapper">
    @for(vehicleType of vehicleTypeOptions; track vehicleType.value){
        <a href="/{{vehicleType.value}}"  [class.active]="selectedVehicleTypeControl?.value == vehicleType.value" class="type-selection-link">
            {{vehicleType.label}}
        </a>
    }
</div>
